//@ts-check
import { useRef, useCallback } from "react";
import { useI18n } from "src/utils/lni18n";
import LnIcon from "src/components/LnIcon";
import WaitRipple from "src/components/WaitRipple";
import LectureControls from "./LectureControls";
import Screen from "../Screen/Screen";
import classes from './player.module.scss';
import lecturePlayerService, { ScreenJumps, currentPlayingStateAtom, currentScreenAtom } from "./LecturePlayerService";
import KeyboardEventHandler from '@infinium/react-keyboard-event-handler';
import { useAtom } from "jotai";
import { Outlet, useNavigate } from "react-router-dom";
import recorderService from "../AudioRecorder/Recoderservice";
import { currentLectureatom } from "../LectureService";



const LecturePlayer = () => {

    const [lectureData] = useAtom(currentPlayingStateAtom);
    const [currentScreen] = useAtom(currentScreenAtom);
    const [currentLecture] = useAtom(currentLectureatom);
    const navigate = useNavigate();
    const lectureElement = useRef(null);
    const { languageService: t } = useI18n();




    const handleKeyEvent = useCallback((key: string) => {

        //const key = event.which || event.keyCode;
        let num = -1;

        switch (key) {
            case "left":
                num = lecturePlayerService.shiftScreenNumber(ScreenJumps.prev);
                break;
            case "right":
                num = lecturePlayerService.shiftScreenNumber(ScreenJumps.next);
                break;

            case "esc":
                if (!recorderService.dialogOpen) {
                    navigate("./../../");
                }
                break;

            case "space":
                lecturePlayerService.togglePlayingState();
                break;
            default:
                break;
        }

        if (num > -1) {
            navigate(`./../../${num}/play`);
        }

    }, []);



    if (!lectureData) {
        return <div>No data</div>;
    }



    const { controlsState: { visible: controlsVisible } } = lectureData;

    const setControlsVisible = (e: any, state: boolean) => {
        lecturePlayerService.setVisibleControls(state);
    }


    if (!currentLecture) {
        console.error("Current lecture not found");
        return <WaitRipple />
    }

    return (<>

        {currentLecture.ScreenWithNewRecording === undefined && currentLecture.ScreenWithAudioEditing === undefined &&
            <div className={classes.lecture} ref={lectureElement} >
                <KeyboardEventHandler
                    handleKeys={['esc', 'left', 'right', 'space']}
                    onKeyEvent={(key: string, e: any) => handleKeyEvent(key)} >
                </KeyboardEventHandler>

                <Screen currentScreen={currentScreen} lectureData={lectureData} className={classes.screen + " pointer"} />
                <LectureControls />

                {!controlsVisible &&
                    <button title={t.getText("display")} className={classes.showControlsButton + " " + classes.roundButton + " btn btn-link d-flex align-items-center"} onClick={(e) => setControlsVisible(e, true)}>
                        <LnIcon className="" name="show-controls" />
                    </button>

                }

                {/* {showForumDialog && <ForumThreadInLectureDialog container={lectureElement} />}
            {showTestDialog && <TestInLectureDialog container={lectureElement} />} */}


            </div >
        }

        <Outlet />
    </>
    )
}


export default LecturePlayer;